<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <!-- Header -->
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
        <span class="w-11 h-11 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 text-slate-900 inline-flex items-center justify-center shadow-[0_8px_20px_-6px_rgba(251,191,36,0.55)]">
          <span class="material-icons">forum</span>
        </span>
        คู่มือช่วยเหลือ LINE
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        จัดการเมนู Flex และรูปคู่มือใน OA — ธีม CityParking (Navy / Amber)
      </p>
    </div>
    <div class="flex flex-col sm:flex-row sm:items-center gap-3 self-start md:self-end">
      <div class="inline-flex items-center gap-2 h-[46px] pl-3 pr-1.5 rounded-2xl bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700 shadow-sm">
        <div class="flex flex-col justify-center min-w-[7.5rem] pr-1 border-r border-slate-100 dark:border-slate-700">
          <span class="text-[10px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
          <span class="text-[13px] font-bold leading-none tabular-nums"
            [class.text-slate-600]="lastFetchedTime()"
            [class.dark:text-slate-300]="lastFetchedTime()"
            [class.text-slate-300]="!lastFetchedTime()"
            [class.dark:text-slate-600]="!lastFetchedTime()">
            {{ lastFetchedTime() ? (lastFetchedTime() | date:'HH:mm:ss') : '--:--:--' }}
          </span>
        </div>
        <button type="button" (click)="load()" [disabled]="isLoading() || isSaving()" title="โหลดข้อมูลใหม่"
          class="w-9 h-9 rounded-xl text-slate-500 hover:text-amber-500 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-all flex items-center justify-center disabled:opacity-40 cursor-pointer">
          <span class="material-icons text-[20px]" [class.animate-spin]="isLoading()">refresh</span>
        </button>
      </div>
      <button *ngIf="canShowActivityHistory" type="button" (click)="openHistory()"
        class="px-4 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-600 dark:text-slate-300 font-bold rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all flex items-center justify-center gap-2">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <button *ngIf="canUpdate" type="button" (click)="onSave()" [disabled]="isSaving() || isLoading()"
        class="px-6 h-[46px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 disabled:opacity-40 border-none">
        <span class="material-icons text-[18px]">{{ isSaving() ? 'hourglass_top' : 'save' }}</span>
        {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
      </button>
    </div>
  </div>

  <div class="relative space-y-6 animate-fade-in">
    <!-- Menu meta + preview -->
    <section class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8">
      <div class="rounded-xl border border-sky-200 bg-sky-50/70 dark:bg-sky-950/20 p-3 text-sm text-sky-900 dark:text-sky-100 mb-5">
        ตั้งข้อความเปิดเมนูและหัวข้อ — ลูกค้าพิมพ์ trigger แล้วเห็น Flex ตามพรีวิวด้านขวา
      </div>

      <div class="grid grid-cols-1 xl:grid-cols-5 gap-6">
        <div class="xl:col-span-3 space-y-4">
          <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">tune</span>
            เมนูช่วยเหลือ
          </h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ข้อความเปิดเมนู (trigger)</label>
              <input
                class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                name="menuTriggerText"
                [ngModel]="menu().triggerText"
                (ngModelChange)="patchMenu({ triggerText: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate"
                placeholder="ติดต่อสอบถาม/แจ้งปัญหา" />
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">หัวข้อ (title)</label>
              <input
                class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                name="menuTitleTh"
                [ngModel]="menu().titleTh"
                (ngModelChange)="patchMenu({ titleTh: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate" />
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">คำอธิบายสั้น</label>
              <input
                class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                name="menuSubtitleTh"
                [ngModel]="menu().subtitleTh"
                (ngModelChange)="patchMenu({ subtitleTh: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate" />
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">altText (แจ้งเตือน LINE)</label>
              <input
                class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                name="menuAltText"
                [ngModel]="menu().altText"
                (ngModelChange)="patchMenu({ altText: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate" />
            </div>
            <div class="flex flex-wrap items-center gap-4 md:col-span-2">
              <label class="inline-flex items-center gap-2 font-bold text-slate-700 dark:text-slate-200 cursor-pointer select-none">
                <input type="checkbox" class="rounded border-slate-300 text-amber-500 focus:ring-amber-400"
                  name="menuIsActive"
                  [ngModel]="menu().isActive"
                  (ngModelChange)="patchMenu({ isActive: $event })"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="!canUpdate" />
                เปิดใช้งานเมนูนี้
              </label>
              <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-slate-100 dark:bg-slate-800 text-[11px] font-bold text-slate-500">
                <span class="material-icons text-[14px]">key</span>
                {{ menu().key || 'help_menu' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Preview -->
        <div class="xl:col-span-2">
          <p class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">พรีวิว Flex</p>
          <div class="max-w-sm mx-auto xl:mx-0 rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-700 shadow-lg">
            <div class="bg-[#1E242B] px-4 pt-1 pb-4">
              <div class="h-0.5 bg-[#F2A900] -mx-4 mb-3"></div>
              <div class="text-[10px] font-bold tracking-wide text-[#F2A900]">CITY PARKING</div>
              <div class="text-white font-bold text-lg mt-1">{{ menu().titleTh || 'ศูนย์ช่วยเหลือ' }}</div>
              <div class="text-[#A8B0B8] text-xs mt-1">{{ menu().subtitleTh || 'เลือกหัวข้อที่ต้องการ' }}</div>
            </div>
            <div class="bg-[#F8F9FA] p-3 space-y-2">
              <div *ngFor="let item of menu().items; trackBy: trackByItemUiKey"
                class="rounded-xl px-3 py-2.5 text-center text-xs font-semibold transition-opacity"
                [class.opacity-40]="!item.isActive"
                [ngClass]="{
                  'bg-[#EEF0F2] text-slate-800': item.style === 'call',
                  'bg-[#F2A900] text-slate-900': item.style === 'amber',
                  'bg-[#1E242B] text-white': item.style === 'navy' || !item.style
                }">
                {{ item.label || '(ไม่มีชื่อปุ่ม)' }}
              </div>
              <div *ngIf="!menu().items.length" class="text-xs text-slate-400 text-center py-4 font-medium">ยังไม่มีปุ่ม</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Menu buttons -->
    <section class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-4">
      <div class="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">smart_button</span>
            ปุ่มในเมนู
          </h2>
          <p class="text-xs text-slate-400 mt-1">เลือกคู่มือ / ลิงก์ / โทร ตามประเภทปุ่ม</p>
        </div>
        <button *ngIf="canUpdate" type="button" (click)="addItem()"
          class="px-4 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold text-xs shadow-sm flex items-center gap-1.5 transition-all border-none">
          <span class="material-icons text-[16px]">add</span>
          เพิ่มปุ่ม
        </button>
      </div>

      <div class="space-y-4">
        <div *ngFor="let item of menu().items; let i = index; trackBy: trackByItemUiKey"
          class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/40 p-4 md:p-5 space-y-3">
          <div class="flex flex-wrap items-center justify-between gap-2">
            <div class="flex items-center gap-2">
              <span class="inline-flex w-8 h-8 items-center justify-center rounded-lg bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 text-xs font-black">{{ i + 1 }}</span>
              <span class="text-xs font-bold text-slate-400">sort {{ item.sortOrder }}</span>
            </div>
            <div class="flex gap-1" *ngIf="canUpdate">
              <button type="button" (click)="moveItem(i, -1)" title="ขึ้น"
                class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-400 hover:text-amber-500 transition-all">
                <span class="material-icons text-base">arrow_upward</span>
              </button>
              <button type="button" (click)="moveItem(i, 1)" title="ลง"
                class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-400 hover:text-amber-500 transition-all">
                <span class="material-icons text-base">arrow_downward</span>
              </button>
              <button type="button" (click)="removeItem(i)" title="ลบ"
                class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-rose-100 dark:border-rose-900/40 bg-rose-50 dark:bg-rose-900/20 text-rose-500 hover:bg-rose-100 transition-all">
                <span class="material-icons text-base">delete</span>
              </button>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            <div>
              <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">ชื่อปุ่ม</label>
              <input class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                [name]="'itemLabel-' + item.uiKey"
                [ngModel]="item.label"
                (ngModelChange)="patchItem(i, { label: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate" />
            </div>
            <div>
              <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">ประเภท</label>
              <select class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                [name]="'itemActionType-' + item.uiKey"
                [ngModel]="item.actionType"
                (ngModelChange)="patchItem(i, { actionType: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate">
                <option *ngFor="let o of actionOptions" [value]="o.value">{{ o.label }}</option>
              </select>
            </div>
            <div>
              <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">สไตล์</label>
              <select class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                [name]="'itemStyle-' + item.uiKey"
                [ngModel]="item.style"
                (ngModelChange)="patchItem(i, { style: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate">
                <option *ngFor="let o of styleOptions" [value]="o.value">{{ o.label }}</option>
              </select>
            </div>

            <div class="md:col-span-2" *ngIf="item.actionType === 'message' || item.actionType === 'image'">
              <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">เลือกคู่มือที่จะส่ง</label>
              <select
                class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                [name]="'itemGuidePick-' + item.uiKey"
                [ngModel]="item.guideKey || ''"
                (ngModelChange)="onPickGuide(i, $event)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate">
                <option value="">— เลือกคู่มือ —</option>
                <option *ngFor="let g of guidePickerOptions()" [value]="g.matchKey">{{ g.label }}</option>
              </select>
              <p class="text-[10px] text-slate-400 mt-1">
                ส่งข้อความ matchText ของคู่มือ → webhook ตอบด้วยรูป/ลิงก์ตามที่ตั้งไว้
              </p>
            </div>

            <div class="md:col-span-2" *ngIf="item.actionType === 'uri' || item.actionType === 'liff'">
              <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">
                {{ item.actionType === 'liff' ? 'LIFF / URL' : 'tel: หรือ URL' }}
              </label>
              <input class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                [name]="'itemActionValue-' + item.uiKey"
                [ngModel]="item.actionValue"
                (ngModelChange)="patchItem(i, { actionValue: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate"
                [placeholder]="item.actionType === 'liff' ? 'https://liff.line.me/...' : 'tel:020962255'" />
            </div>

            <div class="flex items-end pb-2">
              <label class="inline-flex items-center gap-2 text-xs font-bold text-slate-700 dark:text-slate-200 cursor-pointer select-none">
                <input type="checkbox" class="rounded border-slate-300 text-amber-500 focus:ring-amber-400"
                  [name]="'itemIsActive-' + item.uiKey"
                  [ngModel]="item.isActive"
                  (ngModelChange)="patchItem(i, { isActive: $event })"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="!canUpdate" />
                แสดงปุ่มนี้
              </label>
            </div>
          </div>
        </div>

        <div *ngIf="!menu().items.length"
          class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 py-12 text-center text-slate-400">
          <span class="material-icons text-3xl mb-2 opacity-40 block">smart_button</span>
          <p class="font-bold">ยังไม่มีปุ่ม</p>
          <p class="text-xs mt-1">กด “เพิ่มปุ่ม” เพื่อเริ่มตั้งเมนู</p>
        </div>
      </div>
    </section>

    <!-- Guide contents -->
    <section class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-4">
      <div class="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">menu_book</span>
            คู่มือ (คำตอบ)
          </h2>
          <p class="text-xs text-slate-400 mt-1">
            แนบรูปได้ก่อน · กดบันทึกจึงอัปโหลด · แล้วไปเลือกคู่มือที่ปุ่มในเมนู
          </p>
        </div>
        <button *ngIf="canUpdate" type="button" (click)="addContent()"
          class="px-4 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold text-xs shadow-sm flex items-center gap-1.5 transition-all border-none">
          <span class="material-icons text-[16px]">add</span>
          เพิ่มคู่มือ
        </button>
      </div>

      <div class="space-y-4">
        <div *ngFor="let c of contents(); let i = index; trackBy: trackByContentUiKey"
          class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/40 p-4 md:p-5 space-y-3">
          <div class="flex flex-wrap items-center justify-between gap-2">
            <div class="flex items-center gap-2 min-w-0">
              <span class="inline-flex w-8 h-8 shrink-0 items-center justify-center rounded-lg bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 text-xs font-black">{{ i + 1 }}</span>
              <span class="text-xs font-bold text-slate-500 truncate">{{ c.matchKey || 'คู่มือใหม่' }}</span>
            </div>
            <button *ngIf="canUpdate" type="button" (click)="removeContent(i)" title="ลบ"
              class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-rose-100 dark:border-rose-900/40 bg-rose-50 dark:bg-rose-900/20 text-rose-500 hover:bg-rose-100 transition-all">
              <span class="material-icons text-base">delete</span>
            </button>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            <div>
              <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">matchKey</label>
              <input class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                [name]="'contentMatchKey-' + c.uiKey"
                [ngModel]="c.matchKey"
                (ngModelChange)="patchContent(i, { matchKey: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate" />
            </div>
            <div>
              <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">matchText (ข้อความจากลูกค้า)</label>
              <input class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                [name]="'contentMatchText-' + c.uiKey"
                [ngModel]="c.matchText"
                (ngModelChange)="patchContent(i, { matchText: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate" />
            </div>
            <div>
              <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">ประเภทคำตอบ</label>
              <select class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                [name]="'contentReplyType-' + c.uiKey"
                [ngModel]="c.replyType"
                (ngModelChange)="patchContent(i, { replyType: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate">
                <option *ngFor="let o of replyOptions" [value]="o.value">{{ o.label }}</option>
              </select>
            </div>

            <div class="md:col-span-2 lg:col-span-3" *ngIf="c.replyType === 'image'">
              <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">รูปคู่มือ (สูงสุด 10MB)</label>
              <div class="flex flex-wrap items-start gap-4">
                <div
                  (click)="openImageModal(contentImageSrc(c))"
                  class="relative shrink-0 cursor-zoom-in group/img overflow-hidden rounded-2xl w-32 h-20 bg-slate-100 dark:bg-slate-700 border border-slate-100 dark:border-slate-600 shadow-sm"
                  title="คลิกขยาย">
                  <img
                    [src]="contentImageSrc(c)"
                    class="w-full h-full object-cover transition-transform duration-500 group-hover/img:scale-110"
                    alt="guide preview" />
                  <div class="absolute inset-0 bg-black/0 group-hover/img:bg-black/10 transition-all"></div>
                  <span *ngIf="c.pendingBase64"
                    class="absolute bottom-0 left-0 right-0 text-center text-[9px] font-bold bg-amber-400/90 text-slate-900 py-0.5">
                    รออัปโหลด
                  </span>
                </div>
                <div class="flex flex-col gap-2 min-w-0 flex-1">
                  <div class="flex flex-wrap gap-2 items-center">
                    <label *ngIf="canUpdate"
                      class="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-300 border border-amber-100 dark:border-amber-800/50 text-xs font-bold cursor-pointer hover:bg-amber-100/80 transition-colors">
                      <span class="material-icons text-sm">attach_file</span>
                      {{ c.pendingBase64 || c.imageUrl ? 'เปลี่ยนรูป' : 'แนบรูป' }}
                      <input type="file" accept="image/*" class="sr-only" (change)="onImageSelected(i, $event)" />
                    </label>
                    <button *ngIf="canUpdate && (c.imageUrl || c.pendingBase64)" type="button"
                      class="px-3 py-2 rounded-xl border border-slate-100 dark:border-slate-700 text-xs font-bold text-slate-500 hover:text-rose-500 transition-colors"
                      (click)="clearPendingOrImage(i)">
                      ล้างรูป
                    </button>
                  </div>
                  <p class="text-[10px] text-slate-400">
                    แนบไว้ก่อนได้ · กด <span class="font-bold">บันทึก</span> จึงอัปโหลด · หรือวาง URL HTTPS ด้านล่าง
                  </p>
                  <input
                    class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-xs outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                    [name]="'contentImageUrl-' + c.uiKey"
                    [ngModel]="c.imageUrl"
                    (ngModelChange)="patchContent(i, { imageUrl: $event })"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="!canUpdate || !!c.pendingBase64"
                    placeholder="หรือวาง URL รูป HTTPS โดยตรง" />
                </div>
              </div>
            </div>

            <div class="md:col-span-2" *ngIf="c.replyType === 'text'">
              <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">ข้อความตอบกลับ</label>
              <textarea rows="2"
                class="w-full px-3 py-2.5 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200 resize-none disabled:opacity-60"
                [name]="'contentTextBody-' + c.uiKey"
                [ngModel]="c.textBody"
                (ngModelChange)="patchContent(i, { textBody: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate"></textarea>
            </div>

            <div class="md:col-span-2" *ngIf="c.replyType === 'uri' || c.replyType === 'liff'">
              <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">
                {{ c.replyType === 'liff' ? 'LIFF URL' : 'URL เว็บ' }}
              </label>
              <input class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                [name]="'contentLinkUrl-' + c.uiKey"
                [ngModel]="c.imageUrl"
                (ngModelChange)="patchContent(i, { imageUrl: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate"
                [placeholder]="c.replyType === 'liff' ? 'https://liff.line.me/...' : 'https://...'" />
              <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1 mt-2">ข้อความบนปุ่ม (ไม่บังคับ)</label>
              <input class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                [name]="'contentLinkLabel-' + c.uiKey"
                [ngModel]="c.textBody"
                (ngModelChange)="patchContent(i, { textBody: $event })"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!canUpdate"
                placeholder="เปิดดูรายละเอียด" />
            </div>

            <div class="flex items-end pb-2">
              <label class="inline-flex items-center gap-2 text-xs font-bold text-slate-700 dark:text-slate-200 cursor-pointer select-none">
                <input type="checkbox" class="rounded border-slate-300 text-amber-500 focus:ring-amber-400"
                  [name]="'contentIsActive-' + c.uiKey"
                  [ngModel]="c.isActive"
                  (ngModelChange)="patchContent(i, { isActive: $event })"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="!canUpdate" />
                เปิดใช้
              </label>
            </div>
          </div>
        </div>

        <div *ngIf="!contents().length"
          class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 py-12 text-center text-slate-400">
          <span class="material-icons text-3xl mb-2 opacity-40 block">menu_book</span>
          <p class="font-bold">ยังไม่มีคู่มือ</p>
          <p class="text-xs mt-1">กด “เพิ่มคู่มือ” เพื่อสร้างคำตอบรูปหรือข้อความ</p>
        </div>
      </div>
    </section>
  </div>
</div>

<app-pss-loading *ngIf="isLoading() || isSaving()"></app-pss-loading>

<div *ngIf="showImageModal"
  class="fixed inset-0 z-[99999] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4"
  (click)="closeImageModal()">
  <button type="button" class="absolute top-4 right-4 text-white hover:text-amber-400 transition-colors z-[10000]"
    (click)="closeImageModal()">
    <span class="material-icons text-4xl">close</span>
  </button>
  <div class="relative max-w-[90vw] max-h-[90vh] overflow-hidden rounded-2xl shadow-2xl border border-white/10"
    (click)="$event.stopPropagation()">
    <img [src]="selectedImageUrl" class="object-contain max-w-full max-h-[90vh]" alt="Enlarged Image">
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory"
  [entityType]="activityEntityTypes.LineGuideMenu"
  [entityId]="menu().id"
  title="ประวัติคู่มือช่วยเหลือ LINE"
  (close)="showActivityHistory = false">
</app-modal-admin-activity-history>
